"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RecipientType;
(function (RecipientType) {
    RecipientType[RecipientType["None"] = 0] = "None";
    RecipientType[RecipientType["To"] = 1] = "To";
    RecipientType[RecipientType["Cc"] = 2] = "Cc";
    RecipientType[RecipientType["Bcc"] = 3] = "Bcc";
})(RecipientType = exports.RecipientType || (exports.RecipientType = {}));
//# sourceMappingURL=RecipientType.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-recipient-common/lib/store/schema/RecipientType.js
// module id = 2672
// module chunks = 2 3 4